export const BUTTON_IMAGES = {
  REWIND: '',
  PLAY: '',
  PAUSE: '',
  FAST_FORWARD: '',
}

export const KEY_CODE = {
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  FF: 228,
  RW: 227,
  PLAY_PAUSE: 179,
  OK: 13,
  MEDIA_PLAY_PAUSE: 10252,
  MEDIA_RW: 412,
  MEDIA_FF: 417,
  MEDIA_PLAY: 415,
  MEDIA_PAUSE: 19,
  MEDIA_STOP: 413,
}

export const PLAYER_EVENTS = {
  STARTED: 'Started',
  PAUSED: 'Paused',
  RESUMED: 'Resumed',
  PLAYING: 'Playing',
  COMPLETED: 'Completed',
  INTERRUPTED: 'Interrupted',
  SEEK_COMPLETED: 'Seek Completed',
  SETTINGS_TOGGLED: 'Settings Toggled',
}

export const CONTENT_PLAYING_TIME_INTERVAL = 10
